// Marketing nav — sticky bar with brand, beta pill, 4 main pills, secondary "For devs", primary CTA.
// Source canonical: design-system/project/homepage/index.html § <nav>

import AirgentLogo from '../components/AirgentLogo';
import Wordmark from '../components/Wordmark';

const NAV_LINKS: { label: string; href: string }[] = [
  { label: 'Roster',       href: '#roster' },
  { label: 'How it works', href: '#how' },
  { label: 'Pricing',      href: '#pricing' },
  { label: 'Why Airgent',  href: '#why' },
];

export default function Nav() {
  return (
    <nav
      className="nav-bar"
      style={{
        position: 'sticky', top: 0, zIndex: 50,
        display: 'flex', alignItems: 'center', gap: 28,
        padding: '18px 40px',
        background: 'rgba(35,33,32,0.85)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }} aria-label="Airgent home">
        <AirgentLogo size={32} />
        <Wordmark size="xs" />
      </a>

      <span
        className="nav-beta-pill"
        style={{
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: 10, fontWeight: 600,
          letterSpacing: '0.08em', textTransform: 'uppercase',
          color: 'var(--signal-400)',
          border: '1px solid rgba(212,131,94,0.30)',
          background: 'rgba(212,131,94,0.10)',
          padding: '4px 9px', borderRadius: 4, marginLeft: 4,
        }}
      >
        Private Beta
      </span>

      <div className="nav-links" style={{ display: 'flex', gap: 8, marginLeft: 28 }}>
        {NAV_LINKS.map((x) => (
          <a key={x.label} href={x.href} className="nav-pill">{x.label}</a>
        ))}
      </div>

      <div style={{ marginLeft: 'auto', display: 'flex', gap: 10, alignItems: 'center' }}>
        <a href="#waitlist" className="nav-pill nav-pill-secondary nav-secondary">For devs →</a>
        <a href="#waitlist" className="nav-cta">Join the waitlist</a>
      </div>
    </nav>
  );
}
